import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 5%;
  width: 95%;
  height: 100%;
  h1 {
    font-size: 40px;
    font-weight: 900;
    margin: 20px;
    padding: 20px;
  }
`;
